import React from 'react';

const Difficulty: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 20.43c-1.85-1.73-3-4.2-3-6.93C3 8.25 7.25 4 12.5 4S22 8.25 22 13.5a9.48 9.48 0 01-3 6.93"
      stroke="#5A6474"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3 13.5h2M6 7l1 1M12.5 6V4M19.8 13.5h2M14 12l3-3"
      stroke="#5A6474"
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Difficulty;
